// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/altrv-and-moa.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/altrv-and-moa/altrv-and-moa.js';

mount([g0]);
